module.exports = __webpack_public_path__ + "img/usdc.dda63f74.svg";